

import { Component, VModel, Vue } from "vue-property-decorator";
import IBDialog from "@/components/Dialog/IBDialog.vue";

@Component({
	components: {
		IBDialog
	}
})
export default class DigitalSignNotFoundDialog extends Vue {

	@VModel({ type: Boolean })
	model!: boolean

}

